module.exports = "/images/collapse.svg?197093be43dc030aaa803d06dd9e6696";